<!--
 * @Author: 仙道
 * @Date: 2022-08-27 18:13:23
 * @LastEditTime: 2024-08-22 11:21:37
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-wf-web/src/components/jeecgbiz/modal/JSelectDeviceByProcessModal.vue
-->
<template>
  <j-modal
    :title="title"
    :visible="visible"
    :width="modalWidth"
    @cancel="close"
    @ok="handleSubmit"
    cancelText="关闭"
    style="top:50px"
    switchFullscreen
    wrapClassName="j-user-select-modal"
  >
    <a-row :gutter="10" style="background-color: #ececec; padding: 10px; margin: -10px">
      <a-col :md="6" :sm="24" v-show="decProcessTree.length > 0">
        <a-card :bordered="false">
          <!--组织机构-->
          <a-directory-tree
            :checkStrictly="true"
            :dropdownStyle="{maxHeight:'200px',overflow:'auto'}"
            :expandAction="false"
            :selectedKeys="selectedProcessIds"
            :treeData="decProcessTree"
            @select="onTreeNodeSelect"
            selectable
          />
        </a-card>
      </a-col>
      <a-col :md="decProcessTree.length > 0 ? 18 : 24" :sm="24">
        <a-card :bordered="false">
          设备名称：
          <a-input-search
            :style="{width:'300px',marginBottom:'15px'}"
            @search="onSearch"
            placeholder="请输入设备名称"
            v-debounce="onSearch"
            v-model="queryParam.devName"
          ></a-input-search>
          <a-button @click="searchReset(1)" icon="redo" style="margin-left: 20px">重置</a-button>
          <!--列表-->
          <a-table
            :columns="columns"
            :dataSource="dataSource"
            :loading="loading"
            :pagination="ipagination"
            :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,type: getType}"
            :scroll="scrollTrigger"
            @change="handleTableChange"
            ref="table"
            rowKey="id"
            size="middle"
          ></a-table>
        </a-card>
      </a-col>
    </a-row>
  </j-modal>
</template>

<script>
  import { pushIfNotExist, filterObj } from '@/utils/util'
  import { getAction } from '@/api/manage'

  export default {
    name: 'JSelectDeviceByProcessModal',
    components: {},
    props: ['modalWidth', 'multi', 'userIds', 'store', 'text'],
    data () {
      return {
        queryParam: {
          username: "",
        },
        columns: [
          {
            title: '设备名称',
            align: 'center',
            dataIndex: 'devName',
            sorter: true,
          },
          {
            title: '表号',
            align: 'center',
            dataIndex: 'devTag',
            sorter: true,
          },

        //   {
        //     title: '设备类型',
        //     align: 'center',
        //     dataIndex: 'devClassId_dictText'
        //   },
          {
            //devTypeId_dictText
            title: '设备型号',
            align: 'center',
            dataIndex: 'devTypeId_dictText',
            sorter: true,
          },
        //   {
        //     title: '区域',
        //     align: 'center',
        //     dataIndex: 'region',
        //     sorter: true,
        //     scopedSlots: { customRender: 'pcaSlot' }
        //   },
          {
            title: '安装位置',
            align: 'left',
            dataIndex: 'location',
            scopedSlots: { customRender: 'locationSlot' },
            sorter: true
          },

        ],
        scrollTrigger: {},
        dataSource: [],
        selectionRows: [],
        selectedRowKeys: [],
        selectDevRows: [],
        selectDevIds: [],
        title: '选择设备',
        ipagination: {
          current: 1,
          pageSize: 50,
          pageSizeOptions: ['10', '20', '50', '100', '200'],
          showTotal: (total, range) => {
            return range[0] + '-' + range[1] + ' 共' + total + '条'
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        isorter: {
          column: 'createTime',
          order: 'desc'
        },
        selectedProcessIds: [],
        decProcessTree: [],
        visible: false,
        form: this.$form.createForm(this),
        loading: false,
        expandedKeys: [],
        url: {
          getProcessList: "/device/devProcess/list",
        }
      }
    },
    computed: {
      // 计算属性的 getter
      getType: function () {
        return this.multi == true ? 'checkbox' : 'radio';
      }
    },
    watch: {
      userIds: {
        immediate: true,
        handler () {
          this.initDevices()
        }
      },
    },
    created () {
      // 该方法触发屏幕自适应
      this.resetScreenSize();
      this.loadData()
    },
    methods: {
      initDevices () {
        if (this.userIds) {
          // 这里最后加一个 , 的原因是因为无论如何都要使用 in 查询，防止后台进行了模糊匹配，导致查询结果不准确
          let values = this.userIds.split(',') + ','
          let param = { [this.store]: values }
          getAction('/device/devList/list', param).then((list) => {
            this.selectionRows = []
            let selectedRowKeys = []
            let textArray = []
            if (list && list.length > 0) {
              for (let user of list) {
                textArray.push(user[this.text])
                selectedRowKeys.push(user['id'])
                this.selectionRows.push(user)
              }
            }
            this.selectedRowKeys = selectedRowKeys
            this.$emit('initComp', textArray.join(','))
          })

        } else {
          // JSelectUserByDep组件bug issues/I16634
          this.$emit('initComp', '')
          // 前端用户选择单选无法置空的问题 #2610
          this.selectedRowKeys = []
        }
      },
      async loadData (arg) {
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        let params = this.getQueryParams()//查询条件
        this.loading = true
        getAction('/device/devList/list', params).then(res => {
          if (res.success) {
            this.dataSource = res.result.records
            this.ipagination.total = res.result.total
          }
        }).finally(() => {
          this.loading = false
        })
      },
      // 触发屏幕自适应
      resetScreenSize () {
        let screenWidth = document.body.clientWidth;
        if (screenWidth < 500) {
          this.scrollTrigger = { x: 800 };
        } else {
          this.scrollTrigger = {};
        }
      },
      showModal () {
        this.visible = true;
        this.getProcessTree();
        this.initDevices()
        this.loadData();
        this.form.resetFields();
      },
      getQueryParams () {
        let param = Object.assign({}, this.queryParam, this.isorter);
        param.field = this.getQueryField();
        param.pageNo = this.ipagination.current;
        param.pageSize = this.ipagination.pageSize;
        param.devProcessId = this.selectedProcessIds.join(',')
        return filterObj(param);
      },
      getQueryField () {
        let str = 'id,';
        for (let a = 0; a < this.columns.length; a++) {
          str += ',' + this.columns[a].dataIndex;
        }
        return str;
      },
      searchReset (num) {
        let that = this;
        that.selectedRowKeys = [];
        that.selectDevIds = [];
        that.selectedProcessIds = [];
        if (num !== 0) {
          that.queryParam = {};
          that.loadData(1);
        }
      },
      close () {
        this.searchReset(0);
        this.visible = false;
      },
      handleTableChange (pagination, filters, sorter) {
        //TODO 筛选
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = 'ascend' === sorter.order ? 'asc' : 'desc';
        }
        this.ipagination = pagination;
        this.loadData();
      },
      handleSubmit () {
        let that = this;
        this.getSelectDevRows();
        that.$emit('ok', that.selectDevRows);
        that.searchReset(0)
        that.close();
      },
      //获取选择设备信息
      getSelectDevRows () {
        this.selectDevRows = []
        for (let row of this.selectionRows) {
          if (this.selectedRowKeys.includes(row.id)) {
            this.selectDevRows.push(row)
          }
        }
        this.selectDevIds = this.selectDevRows.map(row => row.id).join(',')
      },
      // 点击树节点,过滤设备
      onTreeNodeSelect (selectedProcessIds) {
        if (selectedProcessIds[0] != null) {
          if (this.selectedProcessIds[0] !== selectedProcessIds[0]) {
            this.selectedProcessIds = [selectedProcessIds[0]];
          }
          this.loadData(1);
        }
      },
      onSelectChange (selectedRowKeys, selectionRows) {
        this.selectedRowKeys = selectedRowKeys;
        selectionRows.forEach(row => pushIfNotExist(this.selectionRows, row, 'id'))
      },
      onSearch () {
        this.loadData(1);
      },
      getProcessTree () {
        this.expandedKeys = []
        this.decProcessTree = []
        getAction(this.url.getProcessList, {
          pageSize: 9999,
        }).then((res) => {
          if (res.success) {
            for (let i = 0; i < res.result.records.length; i++) {
              let temp = {
                key: res.result.records[i].id,
                title: res.result.records[i].processName,
              }
              this.decProcessTree.push(temp)
            }
          } else {
            this.$message.error(res.message)
          }
        });
      },
      modalFormOk () {
        this.loadData();
      }
    }
  }
</script>

<style scoped>
  .ant-table-tbody .ant-table-row td {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  #components-layout-demo-custom-trigger .trigger {
    font-size: 18px;
    line-height: 64px;
    padding: 0 24px;
    cursor: pointer;
    transition: color 0.3s;
  }
</style>
